"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var radio_button_1 = require("@csod/radio-button");
exports.RadioButton = radio_button_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["RadioButton"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/RadioButton/RadioButton.js
// module id = 700
// module chunks = 0